<!--
 * @Author: Merlin
 * @Date: 2024-05-29 16:47:38
 * @LastEditors: Gaho
 * @LastEditTime: 2025-01-21 16:06:13
 * @Description: 
-->
<template>
    <div class="header-cell flex pr-3 flex-1 items-center">
        {{ text }}
    </div>
</template>
<script lang="ts" setup>
const props = defineProps({
    text: {
        type: String,
        default: '',
    },

});
</script>
<style scoped lang="scss">
.header-cell{
    letter-spacing: -0.5px;
    line-height: 1;
}
</style>
